import axios from "axios";

import { LOGIN_RESEND, ADDRESS, GRAPHQL_API } from "../../configs/api-config";
import { formatAndRaiseError } from "../../helpers/general";
import { requestHelper } from "../../helpers/request-helper";

function login(cellphone) {
  return requestHelper(
    `
      mutation login($cellphone: String!) {
        proxyLogin(cellphone: $cellphone) {
          token
          expire_time
          tries
          sms_number
          resend_wait_time
        }
      }
    `,
    {
      cellphone: cellphone,
    }
  ).then((data) => {
    return data.proxyLogin;
  });
}

function login_check(token, code) {
  return requestHelper(
    `
      mutation loginCheck($code: String!, $token: String!) {
        proxyVerifyCode(code: $code, token: $token) {
          token
          isNew
        }
      }
    `,
    {
      code: code,
      token: token,
    }
  ).then((data) => {
    return data.proxyVerifyCode;
  });
}

function login_resend(token) {
  return axios.post(LOGIN_RESEND, {
    token,
  });
}

function get_profile(token = "") {
  let headers = undefined;
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return requestHelper(
    `
      query profileData {
        proxyMyProfile {
          first_name
          last_name
          cellphone
          email
          id
          balance
          gift_balance
          total_balance
        }
      }
    `,
    {},
    headers
  )
    .then((data) => {
      return data.proxyMyProfile;
    })
    .catch(formatAndRaiseError);
}

function get_groups(token = "") {
  let headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  let data = JSON.stringify({
    query: `query getList{  
    listGroups{
      id
      purpose
      active
      name
      logo
      agreement{
        promotion_code
      }
    }
  }`,
    variables: {},
  });

  var config = {
    method: "post",
    url: GRAPHQL_API,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then((response) => {
      let { data } = response.data;
      if (data.errors) {
        throw new Error(data.errors);
      }
      return data;
    })
    .then((data) => {
      if (data && data.listGroups) {
        return data.listGroups;
      }

      return data;
    });
}

function get_address() {
  return requestHelper(
    `
        query addressesList {
          proxyMyAddresses {
            id
            title
            address
            latitude
            longitude
          }
        }
      `
  )
    .then((data) => {
      return data.proxyMyAddresses;
    })
    .catch(formatAndRaiseError);
}

function add_address(data) {
  return axios.post(ADDRESS, data);
}

function get_orders() {
  return requestHelper(
    `
      query ordersList {
        proxyMyOrders {
          id
          description
          latest_status
          collection {
            id
            period {
              id
              date
              start
              end
            }
            status
            address_text
            address_latitude
            address_longitude
          }
          delivery {
            id
            period {
              id
              date
              start
              end
            }
            status
            address_text
            address_latitude
            address_longitude
          }
          price_descriptor {
            total_items_amount
            total_extra_charge
            logistic_price
            total_amount
            discount
            cash_back
            toll
            tax
            vat
            total_price
          }
          factor_link
          payment_status
        }
      }
    `
  )
    .then((data) => {
      return data.proxyMyOrders;
    })
    .catch(formatAndRaiseError);
}

function get_transactions() {
  return requestHelper(
    `
      query transactionsList {
        proxyMyTransactions {
          id
          amount
          is_gift
          transaction_type
          description
        }
      }
    `
  )
    .then((data) => {
      return data.proxyMyTransactions;
    })
    .catch(formatAndRaiseError);
}

function set_push_token(token, platform, publisher) {
  let data = JSON.stringify({
    query: `mutation setPush($token: String!, $platform: PushPlatforms!, $publisher: PushPublishers!){  
      setPushToken(token: $token, platform: $platform, publisher:$publisher){
        suceess
      }
  }`,
    variables: { token, platform, publisher },
  });

  var config = {
    method: "POST",
    url: GRAPHQL_API,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then((response) => {
      let { data } = response.data;

      if (data && data.setPushToken) {
        return data.setPushToken;
      }

      return data;
    })
    .finally(console.log);
}

export {
  get_address,
  get_orders,
  get_profile,
  get_groups,
  set_push_token,
  get_transactions,
};

// old
export default {
  login,
  login_check,
  login_resend,
  get_profile,
  get_address,
  add_address,
  get_orders,
  get_groups,
  get_transactions,
};
